import script from "./FixedNav.vue?vue&type=script&setup=true&lang=js"
export * from "./FixedNav.vue?vue&type=script&setup=true&lang=js"

import "./FixedNav.vue?vue&type=style&index=0&id=74625f84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74625f84"]])

export default __exports__